module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "main"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1902.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("Bonell+Dòriga receives the Lisbon Triennale Millennium bcp Début Award 2019!")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1809_2.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1809 | Argia. A Model for the Exhibition \"MIRABILIA Interpretations of Italo Calvino's Invisible Cities")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1809_1.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1809 | Argia. A Model for the Exhibition \"MIRABILIA Interpretations of Italo Calvino's Invisible Cities")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1804.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1804 | Galeria. A Drawing for the Exhibition \"Documents (To Come)\"")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('picture', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    }
  }, [_c('source', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "media": "(max-width: 1999px)",
      "srcset": "../assets/img/1708_lq.jpg"
    }
  }), _vm._v(" "), _c('source', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "media": "(min-width: 2000px)",
      "srcset": "../assets/img/1708.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1708_lq.jpg"),
      "alt": "Bonell+Dòriga"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1708 | Our Workspace. A Drawing for the Publication \"Carnets\"")])], 1)]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1706.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1706 | DGZ Dallwigk. Competition for a new Digital Center in Ingolstadt, First Prize (with Bonell i Gil & the ARGE Falk von Tettenborn & GINA Barcelona architects)\n\t\t\t\t\t, )")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_06.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_05.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1701_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1612_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1612 | LOGMA. Competition in Málaga (in association with MHAP)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1612_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1612 | LOGMA. Competition in Málaga (in association with MHAP)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1611.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1611 | A Series of Rooms. A Collection of Domestic Spaces --> "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.aseriesofrooms.com",
      "target": "_blank"
    }
  }, [_vm._v("HERE")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1610.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1610 | Castellar. Renovation of a Housing Building")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1609.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1609 | Ordinary Floorplans. Contribution to Cartha's \"Issue II - The Architecture of the City. A Palimpsest\"")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1608.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1608 | Sydhavnen. Competition for a New Church in Copenhagen")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1606_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1606_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1606_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_07.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_06.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_05.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1605_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_06.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_05.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1602_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1601_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1601_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1601_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1512_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1512_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("P1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1512_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1512_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1506_05.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1506_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1506_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1506_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1506_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1501.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1501 | Appenzellerhaus. Housing Competition (in association with Carla Ferrando and Pablo Garrido)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1414_05.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1414_04.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1414_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1414_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1414_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1411.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1411 | Loire-et-Loges. Competition, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1410.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1410 | Sessay. Competition")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1408.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1408 | La musa inquiteante. Mannequin for a scarves shop")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1406.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1406 | Tuset Street. Renovation of an Office Space")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1403_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1403_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1403_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1303.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1303 | Plaça Reial Daurada. Competition, Extraordinary Prize")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1201_03.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1201_02.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": require("../assets/img/1201_01.jpg"),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topleftdiv"
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "40px"
    },
    attrs: {
      "src": require("../assets/img/logo.png"),
      "alt": "Bonell+Dòriga"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toprightdiv"
  }, [_vm._v("office@bonelldoriga.com"), _c('br'), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.instagram.com/bonelldoriga",
      "target": "_blank"
    }
  }, [_vm._v("@bonelldoriga")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cf21d34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 2133
// module chunks = 0